/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOfferRequest,
  FullOfferUi,
  OfferInListDTO,
  OfferOptionsRequest,
  OfferTableRequest,
  OfferTableResponse,
  UpdateOfferRequest,
} from '../models';

export interface CreateOfferOperationRequest {
    createOfferRequest: CreateOfferRequest;
}

export interface CreateOffersFromCSVRequest {
    createOfferRequest: Array<CreateOfferRequest>;
}

export interface GetMakeOptionsRequest {
    offerOptionsRequest: OfferOptionsRequest;
}

export interface GetModelOptionsRequest {
    offerOptionsRequest: OfferOptionsRequest;
}

export interface GetOfferByPublicIdRequest {
    publicId: string;
}

export interface GetOfferTableRequest {
    offerTableRequest: OfferTableRequest;
}

export interface GetSourceNameOptionsRequest {
    offerOptionsRequest: OfferOptionsRequest;
}

export interface UpdateOfferOperationRequest {
    updateOfferRequest: UpdateOfferRequest;
}

export interface UpdateOfferStatusRequest {
    publicOfferId: string;
    offerStatus: UpdateOfferStatusOfferStatusEnum;
}

/**
 * 
 */
export class OfferApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async createOfferRaw(requestParameters: CreateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferInListDTO>> {
        if (requestParameters['createOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'createOfferRequest',
                'Required parameter "createOfferRequest" was null or undefined when calling createOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOfferRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createOffer(requestParameters: CreateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferInListDTO> {
        const response = await this.createOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOffersFromCSVRaw(requestParameters: CreateOffersFromCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OfferInListDTO>>> {
        if (requestParameters['createOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'createOfferRequest',
                'Required parameter "createOfferRequest" was null or undefined when calling createOffersFromCSV().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer/fromCSV`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOfferRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createOffersFromCSV(requestParameters: CreateOffersFromCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OfferInListDTO>> {
        const response = await this.createOffersFromCSVRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMakeOptionsRaw(requestParameters: GetMakeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['offerOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'offerOptionsRequest',
                'Required parameter "offerOptionsRequest" was null or undefined when calling getMakeOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer/options/make`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['offerOptionsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMakeOptions(requestParameters: GetMakeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMakeOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getModelOptionsRaw(requestParameters: GetModelOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['offerOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'offerOptionsRequest',
                'Required parameter "offerOptionsRequest" was null or undefined when calling getModelOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer/options/model`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['offerOptionsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getModelOptions(requestParameters: GetModelOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getModelOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOfferByPublicIdRaw(requestParameters: GetOfferByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullOfferUi>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getOfferByPublicId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/offer/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getOfferByPublicId(requestParameters: GetOfferByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullOfferUi> {
        const response = await this.getOfferByPublicIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOfferTableRaw(requestParameters: GetOfferTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferTableResponse>> {
        if (requestParameters['offerTableRequest'] == null) {
            throw new runtime.RequiredError(
                'offerTableRequest',
                'Required parameter "offerTableRequest" was null or undefined when calling getOfferTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer/table`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['offerTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getOfferTable(requestParameters: GetOfferTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferTableResponse> {
        const response = await this.getOfferTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSourceNameOptionsRaw(requestParameters: GetSourceNameOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['offerOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'offerOptionsRequest',
                'Required parameter "offerOptionsRequest" was null or undefined when calling getSourceNameOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer/options/sourceName`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['offerOptionsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getSourceNameOptions(requestParameters: GetSourceNameOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSourceNameOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOfferRaw(requestParameters: UpdateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferInListDTO>> {
        if (requestParameters['updateOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOfferRequest',
                'Required parameter "updateOfferRequest" was null or undefined when calling updateOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/offer`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateOfferRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateOffer(requestParameters: UpdateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferInListDTO> {
        const response = await this.updateOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOfferStatusRaw(requestParameters: UpdateOfferStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferInListDTO>> {
        if (requestParameters['publicOfferId'] == null) {
            throw new runtime.RequiredError(
                'publicOfferId',
                'Required parameter "publicOfferId" was null or undefined when calling updateOfferStatus().'
            );
        }

        if (requestParameters['offerStatus'] == null) {
            throw new runtime.RequiredError(
                'offerStatus',
                'Required parameter "offerStatus" was null or undefined when calling updateOfferStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/offer/{publicOfferId}/status/{offerStatus}`.replace(`{${"publicOfferId"}}`, encodeURIComponent(String(requestParameters['publicOfferId']))).replace(`{${"offerStatus"}}`, encodeURIComponent(String(requestParameters['offerStatus']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateOfferStatus(requestParameters: UpdateOfferStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferInListDTO> {
        const response = await this.updateOfferStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UpdateOfferStatusOfferStatusEnum = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;
export type UpdateOfferStatusOfferStatusEnum = typeof UpdateOfferStatusOfferStatusEnum[keyof typeof UpdateOfferStatusOfferStatusEnum];
